import { render, staticRenderFns } from "./DependencyApplicationsSingle.vue?vue&type=template&id=215e2a60&"
import script from "./DependencyApplicationsSingle.vue?vue&type=script&lang=js&"
export * from "./DependencyApplicationsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports